import { IResults, IErrorType, } from '../state-helpers/search-results';
import * as actions from '../actions/index';
import * as _ from 'lodash';

const defaultResultsModel = Object.freeze({
    searchItemList: [],
    categories: [],
    loading: false,
    currentPage: 1,
    errorMessage: '',
    totalNumber: 0,
    totalPages: 0,
    trackingId: '',
    showResults: true,
    errorType: IErrorType.NONE,
    noResultsWYSIWYG: ""
});


export function resultsModel(state: IResults, action: actions.IResultsLoadedAction) {
    if (typeof state === 'undefined') {
        state = defaultResultsModel
    }

    switch (action.type) {
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: false });
        case actions.ActionType.RESULTS_LOADING:
            return _.assign({}, state, { loading: action.isLoading });
        case actions.ActionType.SHOW_RESULTS:
            return _.assign({}, state, { showResults: action.showResults });
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: true });
        case actions.ActionType.RESULTS_LOADED:
            return _.assign({}, state, {
                loading: false,
                searchItemList: action.results,
                categories: action.categories,
                totalNumber: action.totalNumber,
                totalPages: action.totalPages,
                trackingId: action.trackingId,
                errorMessage: '',
                errorType: IErrorType.NONE,
                noResultsWYSIWYG: action.noResultsWYSIWYG
            });
        case actions.ActionType.RESULTS_LOAD_FAILURE:
            return _.assign({}, state, {
                loading: false,
                errorMessage: action.errorMessage,
                errorType: action.errorType,
                searchItemList: [],
                categories: [],
                totalNumber: 0,
                trackindId: action.trackingId,
                totalPages: 0,
                noResultsWYWIWYG: action.noResultsWYSIWYG
            });
        case actions.ActionType.CLEAR_ERROR_TEXT:
            return _.assign({}, state, { errorMessage: '', errorType: IErrorType.NONE });
        case actions.ActionType.BROWSER_NAVIGATION:
            return _.assign({}, state, {
                currentPage: action.page,
                loading: true
            });
        default:
            return state;
    }
}